import { useLocation as useRouterLocation } from 'react-router-dom';
const useLocation = () => useRouterLocation();
export default useLocation;